import { render, staticRenderFns } from "./ButtonV2.vue?vue&type=template&id=0b503c8b&scoped=true&"
import script from "./ButtonV2.vue?vue&type=script&lang=js&"
export * from "./ButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./ButtonV2.vue?vue&type=style&index=0&id=0b503c8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b503c8b",
  null
  
)

export default component.exports